import { createClient } from 'contentful';

const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID || 'k8iticlf6z7s';
const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || 'ea5af3900ff63f04b9c85677a88b1e79751526d1a552c8f61e2b3e03ef150fdf';
const HOST = process.env.REACT_APP_CONTENTFUL_HOST || 'cdn.contentful.com';

const client = createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  host: HOST,
});

// get navigation
export const getNavi = (locale) => client.getEntries({
  content_type: 'navigation',
  limit: 1,
  include: 2,
  locale,
  select: [
    'fields.entries',
  ],
})
.then(response => response.items[0].fields.entries)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

export const getPage = (slug, locale) => client.getEntries({
  content_type: 'page',
  'fields.slug': slug,
  include: 2,
  locale,
  select: [
    'fields.slug',
    'fields.title',
    'fields.elements',
  ],
})
.then(response => response.items[0].fields)
.catch(error => {
  console.log('error occured')
  console.log(error)
});


export const getReservationTexts = (locale) => client.getEntries({
  content_type: 'reservationTexts',
  limit: 1,
  locale,
  select: [
    'fields.backgroundImage',
    'fields.onlineBookingInfo',
    'fields.groupReservationInfo'
  ]
})
.then(response => ({
  ...response.items[0].fields
}))
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getHours = (locale) => client.getEntries({
  content_type: 'contactUs',
  limit: 1,
  locale,
  select: [
    'fields.openingHours'
  ]
})
.then(response => response.items[0].fields.openingHours)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get front page
export const getFront = (locale) => client.getEntries({
  content_type: 'frontPage',
  limit: 1,
  locale,
  include: 10,
  select: [
    'fields.header',
    'fields.lifts'
  ]
})
.then(response => {
  return {
    "header":response.items[0].fields.header.fields,
    "lifts":response.items[0].fields.lifts
  }
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Menus
export const getMenus = (locale) => client.getEntries({
  content_type: 'menu',
  order: 'fields.order',
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getContact = (locale) => client.getEntries({
  content_type: 'contactUs',
  limit: 1,
  locale,
  select: [
    'fields.header',
    'fields.headers',
    'fields.leftColumn',
    'fields.rightColumn'
  ]
})
.then(response => {
  return {
  "header":response.items[0].fields.header,
  "headers":response.items[0].fields.headers,
  "leftColumn":response.items[0].fields.leftColumn,
  "rightColumn":response.items[0].fields.rightColumn,
  "services":response.items[0].fields.services
}})
.catch(error => {
  console.log('error occured')
  console.log(error)
});



// WEBPACK FOOTER //
// ./src/api/contentfulAPI.js